import React, { useState } from "react";
import { Box, Paper, Tabs, Tab, Typography } from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

import { POPPINS, HEADER_COLOR, PRIMARY } from "./adminConstants";
import DashboardTab from "./DashboardTab";

const TABS = [
  { label: "Dashboard", icon: <AdminPanelSettingsIcon fontSize="small" /> },
];

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
      {/* Page header */}
      <Box sx={{ px: 3, pt: 3, pb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 0.5 }}>
          <AdminPanelSettingsIcon sx={{ color: PRIMARY, fontSize: 28 }} />
          <Typography variant="h6" sx={{ ...POPPINS, fontWeight: 700, color: HEADER_COLOR }}>
            Admin Dashboard
          </Typography>
        </Box>
        <Typography variant="caption" color="text.secondary" sx={POPPINS}>
          Platform overview, user metrics, and login audit.
        </Typography>
      </Box>

      {/* Tabs */}
      <Box sx={{ borderBottom: "1px solid #e0e0e0", px: 2 }}>
        <Tabs
          value={activeTab}
          onChange={(_, v) => setActiveTab(v)}
          TabIndicatorProps={{ style: { backgroundColor: PRIMARY } }}
          sx={{ minHeight: 40 }}
        >
          {TABS.map((t, i) => (
            <Tab
              key={t.label}
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                  {t.icon}
                  <span>{t.label}</span>
                </Box>
              }
              id={`admin-tab-${i}`}
              aria-controls={`admin-tabpanel-${i}`}
              sx={{ ...POPPINS, fontSize: "0.8rem", textTransform: "none", minHeight: 40, fontWeight: 500 }}
            />
          ))}
        </Tabs>
      </Box>

      {/* Content */}
      <Paper elevation={0} sx={{ flex: 1, overflow: "auto", borderRadius: 0 }}>
        {activeTab === 0 && <DashboardTab />}
      </Paper>
    </Box>
  );
};

export default AdminDashboard;

